import "./Solutions.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import designImg from "../assets/design.JPG";
import prototypingImg from "../assets/prototyping.png";
import engineeringImg from "../assets/engineering.png";

const cards = [
    {
        title: "Design",
        title1: "Engineering Lightweight Solutions from the Start",
        desc: "We optimize component geometry, material selection, and manufacturing feasibility using advanced simulation and design tools to deliver lighter, stronger, and more efficient aluminium components.",
        link: "/solutions/sol-design",
        img: designImg,
    },
    {
        title: "Prototyping",
        title1: "Accelerating Validation from Concept to Production",
        desc: "From prototype castings to fully machined and assembled parts, we help customers validate designs faster through flexible manufacturing, rapid iterations, and production-ready engineering support.",
        link: "/solutions/sol-prototyping",
        img: prototypingImg,
    },
    {
        title: "Engineering",
        title1: "Transforming Robust Designs into Scalable Production",
        desc: "Our engineering expertise integrates casting, machining and automation to deliver stable processes, predictable quality and efficient series production for global mobility applications.",
        link: "/solutions/sol-eng",
        img: engineeringImg,
    },
];

export default function Solutions() {
    return (
        <section id="sol">

           

            <div className="lightweighting-wrapper">

                <div className="lightweighting-text">

                    <h3>Solutions</h3>

                    <h3>
                        Integrated Engineering for Lightweight & Smart
                        <br />
                        Manufacturing
                    </h3>

                    <p>
                        At Sundaram Clayton Limited (SCL), we support customers
                        from concept to production.
                        <br />
                        Our solutions combine design-led lightweighting with
                        automation-driven engineering to deliver aluminium
                        components that are efficient, scalable and future-ready.
                    </p>

                </div>

                <div className="lightweighting-image">
                    <img
                        src={require("../assets/sol.JPG")}
                        alt="Solutions"
                    />
                </div>

            </div>


            

            <div className="solutions-cards">

                {cards.map((card, index) => (

                    <div
                        className="solution-card"
                        key={index}
                    >

                        {/* IMAGE */}

                        <div className="card-image">

                            <img
                                src={card.img}
                                alt={card.title}
                                className="card-img-el"
                            />

                        </div>


                        {/* TITLE */}

                        <h3>
                            {card.title}
                        </h3>


                        {/* SUB TITLE */}

                        <h4>
                            {card.title1}
                        </h4>


                        {/* DESCRIPTION */}

                        <p>
                            {card.desc}
                        </p>


                        {/* EXPLORE BUTTON */}

                        <Link
                            to={card.link}
                            className="offer-link"
                        >
                            <span>
                                Explore ↗
                            </span>
                        </Link>

                    </div>

                ))}

            </div>


            {/* FOOTER */}

            <Footer />

        </section>
    );
}